<!-- src/components/booking/OpenTableModal.vue -->
<!-- Global OpenTable modal that can be triggered from anywhere -->
<template>
  <div
    v-if="showModal"
    class="fixed inset-0 z-50 flex items-center justify-center"
    @click.self="closeModal"
  >
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50"></div>
    <!-- Modal Content -->
    <div
      class="relative bg-white rounded-xl p-6 max-w-lg w-full mx-4 shadow-2xl"
    >
      <button
        @click="closeModal"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <h2 class="text-xl font-bold text-gray-800 mb-4 text-center">
        Book a Table
      </h2>
      <!-- OpenTable Widget Container -->
      <div id="global-opentable-widget" class="flex justify-center"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */
import postscribe from "postscribe";
import { openTableEventBus } from "@/utils/eventBus";

export default {
  name: "OpenTableModal",
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    // Listen for open events from anywhere in the app
    openTableEventBus.on("open", this.openModal);
  },
  beforeUnmount() {
    openTableEventBus.off("open", this.openModal);
  },
  methods: {
    openModal() {
      this.showModal = true;
      // Wait for modal to render, then inject the OpenTable widget
      this.$nextTick(() => {
        const container = document.getElementById("global-opentable-widget");
        if (container && !container.hasChildNodes()) {
          postscribe(
            "#global-opentable-widget",
            `<script type='text/javascript' src='//www.opentable.ie/widget/reservation/loader?rid=286047&type=standard&theme=standard&color=1&dark=false&iframe=true&domain=ie&lang=en-IE&newtab=false&ot_source=Restaurant%20website'><\/script>`
          );
        }
      });
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
